import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document",
  style: {"max-width":"650px"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute top-0 end-0 mt-2 me-2 z-index-1" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn-close btn btn-sm btn-circle d-flex flex-center transition-base",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_5 = { class: "modal-body p-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-top-lg py-3 ps-4 pe-6 bg-light" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "mb-1",
    style: {"color":"#004761"}
  }, "Add a Student")
], -1)
const _hoisted_7 = { class: "p-4 pt-2 pb-0" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "modal-footer align-items-center px-4" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Form, {
          id: "student-create-form",
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({ isSubmitting, errors }) => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Input, {
                    id: "student-create-email",
                    label: "Email*",
                    name: "email",
                    classes: "form-control",
                    placeholder: "email@domain.com",
                    error: errors.email
                  }, null, 8, ["error"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Input, {
                    id: "student-create-first-name",
                    label: "First Name",
                    name: "firstName",
                    classes: "form-control",
                    placeholder: "First Name",
                    error: errors.firstName
                  }, null, 8, ["error"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Input, {
                    id: "student-create-last-name",
                    label: "Last Name",
                    name: "lastName",
                    classes: "form-control",
                    placeholder: "Last Name",
                    error: errors.lastName
                  }, null, 8, ["error"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn-primary d-block w-100",
                type: "submit",
                disabled: isSubmitting
              }, " Invite ", 8, _hoisted_12)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}